import axiosInstance from './axiosInstance';

const getTransferById = (transferId) =>
  axiosInstance.get(`/internal/admin/transfers/${transferId}`);

export default getTransferById;
